import { isDarkTheme } from "./is-dark-theme";
import { useColorSchemeStore } from "./use-color-scheme.store";

export const applyStoredTheme = () => {
	const { theme } = useColorSchemeStore.getState();
	const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

	document.documentElement.classList.toggle(
		"dark",
		isDarkTheme({ theme, prefersDark }),
	);
};
